import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import TransparentCoverIcon from 'images/icons/transparent_cover.svg'
import playIcon from 'images/icons/play_release_hover.png'
import { ImageWithFallback } from 'components'
import {
  ItemWrap,
  CoverWrap,
  CoverImg,
  Overlay,
  Transparent,
  PlayButton,
  PlayImg,
  TextWrap
} from './ItemPreview.styles'
import { Tonality } from '@dsny/dsny-component-library'

const ItemPreview = ({
  buttons,
  item,
  title,
  subtitle,
  image,
  fallback,
  onClick,
  onPlay
}) => {
  const [hovered, setHovered] = useState(false)
  const theme = useTheme()
  const onEnter = useCallback(() => setHovered(true), [])
  const onLeave = useCallback(() => setHovered(false), [])

  const TransparentOverlay = () => (
    <Overlay>
      <Transparent src={TransparentCoverIcon} />
      <PlayButton
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          onPlay && onPlay(item)
        }}
      >
        <PlayImg src={playIcon} alt="play button" />
      </PlayButton>
    </Overlay>
  )

  return (
    <ItemWrap
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onClick={() => onClick && onClick(item)}
    >
      <CoverWrap>
        <ImageWithFallback
          as={CoverImg}
          src={image}
          fallback={fallback}
          alt={title}
        />
        {hovered && buttons && <TransparentOverlay />}
      </CoverWrap>
      <TextWrap>
        <Tonality.UIText textStyle="caption" color={theme.colors.neutralW90}>
          {title}
        </Tonality.UIText>
        <Tonality.UIText textStyle="caption" color={theme.colors.neutralW70}>
          {subtitle}
        </Tonality.UIText>
      </TextWrap>
    </ItemWrap>
  )
}

ItemPreview.propTypes = {
  buttons: PropTypes.bool,
  item: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  fallback: PropTypes.string,
  onClick: PropTypes.func,
  onPlay: PropTypes.func
}

export default ItemPreview
